import { SET_FLEET_CONFIG } from './constants';

export const setFleetConfig = payload => ({
  type: SET_FLEET_CONFIG,
  payload,
});
